import { T } from '@tolgee/react';
import Link from 'next/link';
import { Dispatch } from 'react';

import { ArrowLeftSvg } from '../../../../assets/icons';
import useRouterMatch from '../../../../hooks/useRouterMatch';
import { TestPrepAction, TestPrepState } from '../../../../hooks/useTestPrepState';
import { IconWrapper } from '../../../_atoms/IconWrapper';
import { BackButton } from '../intent-refinement/ObjectiveRefinement';

export function TestPrepBackButton({
  dispatch,
  testPrepState,
}: {
  dispatch: Dispatch<TestPrepAction>;
  testPrepState: TestPrepState;
}) {
  const { tenantId } = useRouterMatch();
  if (testPrepState.selectedPage === 1) {
    return (
      <Link href={`/${tenantId}/new`} passHref>
        <a>
          <BackButton
            type="primary"
            icon={
              <IconWrapper height={'30px'} width={'30px'}>
                <ArrowLeftSvg style={{ marginRight: '0px' }} />
              </IconWrapper>
            }
            styles={{
              height: 42,
              width: 110,
            }}
          >
            <T keyName="Back" defaultValue="Back" />
          </BackButton>
        </a>
      </Link>
    );
  }
  return (
    <BackButton
      type="primary"
      onClick={() => {
        dispatch({ type: 'GO_BACK', payload: testPrepState.selectedPage - 1 });
      }}
      icon={
        <IconWrapper height={'30px'} width={'30px'}>
          <ArrowLeftSvg style={{ marginRight: '0px' }} />
        </IconWrapper>
      }
      styles={{
        height: 42,
        width: 110,
      }}
    >
      <T keyName="Back" defaultValue="Back" />
    </BackButton>
  );
}
